<template>
    <div class="CustomAudit">
        <el-select v-if="!data" style="width: 100%;" v-model="status" size="small" placeholder="请选择"
            @change="handelChange">
            <el-option v-for="(opt, _opt) in options" :key="_opt" :label="opt.label" :value="opt.value">
            </el-option>
        </el-select>
        <span v-else>{{ status }}</span>

        <el-dialog title="填写原因" :visible.sync="dialogVisible" :close-on-click-modal="false">
            <div style="padding: 20px;">
                <el-input v-model="message" type="textarea" placeholder="请填写不通过的原因"
                    :autosize="{ minRows: 4, maxRows: 10 }">
                </el-input>
                <div style="text-align: center;margin-top: 20px;">
                    <el-button type="primary" @click="handelClick(true)">确认</el-button>
                    <el-button @click="handelClick(false)">取消</el-button>
                </div>
            </div>
        </el-dialog>

    </div>
</template>

<script>
export default {
    data() {
        return {
            status: "",
            message: "",
            dialogVisible: false
        }
    },
    props: {
        options: {
            type: Array,
            default: () => {
                return []
            }
        },
        data: {
            type: String,
            default: ""
        },
        editable: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        "data": function (val) {
            this.status = val && this.options.find(el => el.value == val).label
        }
    },
    created() {
        if (this.data) {
            this.status = this.data && this.options.find(el => el.value == this.data).label
        }
    },
    methods: {
        handelClick(val) {
            if (val) {
                this.$emit("handelCustomChange", {
                    status: this.status,
                    message: this.message,
                })
            } else {
                this.status = ""
            }
            this.message = ""
            this.dialogVisible = false
        },
        handelChange() {
            if (this.options.find(el => el.value == this.status).check) {
                this.dialogVisible = true
            } else {
                this.$emit("handelCustomChange", {
                    status: this.status,
                    message: this.message,
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog__title {
    text-align: left;
}

/deep/.el-dialog__body {
    padding: 20px;
}
</style>